import React from 'react';
import { StyledWidgetLayout } from './style';

const MinimizedWidget = () => <StyledWidgetLayout className="minimized" mini />;

export default MinimizedWidget;
